export async function createCardBackStrings (modelingPlayerDetailData, imgOrigin) {
  console.log('createCardBackStrings');

  const tmpCardBack = await fetch('/assets/template/playerBack.html')
    .then(res => res.text())
    .then(res => res.trim().replace(/\n\s*/g, ''));

  const cardBackStrings = getReplaceTextStrings(tmpCardBack, modelingPlayerDetailData, imgOrigin);
  const cardBackStringsMap = cardBackStrings.map((str, idx) => {
    return {
      id: modelingPlayerDetailData[idx].id,
      str
    }
  });

  // console.log('cardBackStringsMap', cardBackStringsMap);
  return cardBackStringsMap;
}

const getReplaceTextStrings = (template, listData, imgOrigin) => {
  return listData.map(playerDetail => {
    console.log('template data', playerDetail)
    const modatCardStr = template
      .replace('{{ id }}', playerDetail.id)
      .replace('{{ card_path }}', `${imgOrigin}/player_card/${playerDetail.id}/1384x1840.jpg`)
      .replace('{{ name_en }}', playerDetail.name_en)
      .replace(/{{ name_jp }}/g, playerDetail.name_jp)
      .replace('_data_name_jp', playerDetail.name_jp ? '' : '_nodata')
      .replace('{{ birthday }}', playerDetail.birthday)
      .replace('{{ age }}', playerDetail.age)
      .replace('{{ height }}', playerDetail.height)
      .replace('{{ weight }}', playerDetail.weight)
      .replace('{{ country_code }}', playerDetail.country)
      .replace('_data_country', playerDetail.country ? '' : '_nodata')
      .replace('{{ flag_path }}', playerDetail.country ? `${imgOrigin}/national_flag/${playerDetail.country_code}/data.svg` : '/assets/images/league/under/common/img_flag_japan.png')
      .replace('{{ catchphrase }}', playerDetail.catchphrase)
      .replace('_data_catchphrase', playerDetail.catchphrase ? '' : '_nodata')
      .replace('{{ thumb_path }}', `${imgOrigin}/player/${playerDetail.id}/410x536.png`)
      .replace('_data_param', playerDetail.isCompleteEvaluation ? '' : '_nodata')
      .replace('{{ speed }}', playerDetail.speed.num)
      .replace('{{ speed_bar }}', playerDetail.speed.bar)
      .replace('{{ power }}', playerDetail.power.num)
      .replace('{{ power_bar }}', playerDetail.power.bar)
      .replace('{{ stamina }}', playerDetail.stamina.num)
      .replace('{{ stamina_bar }}', playerDetail.stamina.bar)
      .replace('{{ technique }}', playerDetail.technique.num)
      .replace('{{ technique_bar }}', playerDetail.technique.bar)
      .replace('{{ mental }}', playerDetail.mental.num)
      .replace('{{ mental_bar }}', playerDetail.mental.bar)
      .replace('{{ evaluation }}', playerDetail.evaluation)
      .replace('{{ year_best }}', playerDetail.year_best)
      .replace('{{ round_best }}', playerDetail.round_best)
      .replace('{{ title }}', playerDetail.title)
      .replace('{{ first_place_count }}', playerDetail.first_place_count)
      .replace('{{ winner }}', playerDetail.winner)
      .replace('{{ grades_latest }}', playerDetail.grades_latest);
    return modatCardStr;
  })
}
